import React from 'react';

const LeadContext = React.createContext();

export const LeadProvider = LeadContext.Provider;
export const LeadConsumer = LeadContext.Consumer;

export default LeadContext;